import React, { useState, createContext } from 'react';
import "./styles.css";
import Map from './Map';

export const vizContext = createContext();
export default function Nav() {
    var [viz, setViz] = useState(0);

    return (
        <vizContext.Provider value={viz}>
            <>
                <div className="Nav">
                    <div className="dropdown">
                        <button type="button" className='btn dropdown-toggle' data-bs-toggle="dropdown">Select Map Data</button>
                        <ul className="dropdown-menu">
                            <li><button className='dropdown-item' onClick={() => { setViz(0) }}>Wins Per County</button></li>
                            <li><button className='dropdown-item' onClick={() => { setViz(1) }}>William Ruto</button></li>
                            <li><button className='dropdown-item' onClick={() => { setViz(2) }}>Raila Odinga</button></li>
                            <li><button className='dropdown-item' onClick={() => { setViz(3) }}>George Wajackoyah</button></li>
                            <li><button className='dropdown-item' onClick={() => { setViz(4) }}>Waihiga Mwaure</button></li>
                            <li><button className='dropdown-item' onClick={() => { setViz(5) }}>Total Votes</button></li>
                            <li><button className='dropdown-item' onClick={() => { setViz(6) }}>Registered Voters</button></li>
                            {/* <li><button className='dropdown-item' onClick={() => { setViz(7) }}>Voter TurnOut</button></li> */}
                        </ul>
                    </div>
                </div>
                <Map />
            </>


        </vizContext.Provider>
    );
}